<template>
    <header class="header">
        <div class="container">
            <div class="header-inner">
                <router-link to="/" class="header__logo logo">
                    <img class="header__logo--img logo" src="../assets/img/logo.png" alt="Falcon Media">
                </router-link>

                <nav class="header__nav">
                    <ul class="header__navbar">
                        <li class="header__item">
                            <a href="#" class="header__link">
                                <transition name="slide-fade">
                                    <!-- Header Navigation Menu Icons -->
                                    <button class="header--button" v-if="show" key="on" @click="show = false">
                                        <svg viewBox="0 0 24 24" class="header--icon">
                                            <title>Close</title>
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path fill="currentColor" d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                                        </svg>
                                    </button>
                                    <button class="header--button" v-else key="off" @click="show = true">
                                        <svg viewBox="0 0 24 24" class="header--icon">
                                            <title>Navigation Menu</title>
                                            <path fill="currentColor" d="M6,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM16,6c0,1.1 0.9,2 2,2s2,-0.9 2,-2 -0.9,-2 -2,-2 -2,0.9 -2,2zM12,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2z" />
                                        </svg>
                                    </button>
                                </transition>
                            </a>
                            <transition name="dropdown">
                                <div class="dropdown__menu" v-bind:class="{ active: show }" v-if="show" @click="show = false">
                                    <ul class="dropdown__menu-nav">
                                        <li v-for="menuLink in menuLinks" :key="menuLink.id" class="dropdown__menu-item">
                                            <prismic-link :field="menuLink.link" class="dropdown__menu-link">
                                                <div class="dropdown__menu-text">
                                                    {{ $prismic.richTextAsPlain(menuLink.label) }}
                                                </div>
                                            </prismic-link>
                                        </li>
                                    </ul>
                                </div>
                            </transition>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </header>

</template>

<script>
    export default {
        name: 'HeaderPrismic',

        data() {
            return {
                menuContent: [],
                menuLinks: [],
                show: false,
            }
        },

        methods: {

            getMenu() {
                //Query to get menu content
                this.$prismic.client.getSingle('menu')
                    .then((menuContent) => {
                        this.menuContent = menuContent
                        this.menuLinks = menuContent.data.menu_links
                    })
            },
        },
        created() {
            this.getMenu()
        }
    }
</script>

<style lang="scss">
    /* Site header */
    header {
        position: fixed;
        width: 100%;
        height: 30px;
        top: 0;
        padding: 20px 0;
        background: #00283d;
        z-index: 99;
        @media (max-width: 767px) {
            padding: 15px 0;
        }
        & .header-inner {

                display: grid;
                grid-auto-columns: 5fr 1fr;
                grid-auto-flow: column;

        }
        & .header {
            padding: 0 10%;

            @media (max-width: 1060px) {
                padding-left: 20px;
                padding-right: 20px;
            }
            @media (max-width: 767px) {
                height: auto;
                padding: 0;
                max-width: 100%;
                display: block;
                flex-direction: column;
            }

            &__logo {
                display: grid;
                /*fill: #fff;*/
                width: 200px;
                /*filter: brightness(0) invert(1);*/

                /*&:hover {*/
                /*    fill: #ccc;*/
                /*    filter: brightness(0) invert(0.9);*/
                /*}*/

                @media (max-width: 767px) {
                    display: grid;
                    width: 70%;
                    margin-top: -3px;
                }
            }

            &__nav {
                float: right;
                @media (max-width: 767px) {
                    float: none;
                    text-align: center;
                    margin-top: 0;
                }

                &--ul {
                    margin: 0;
                    @media (max-width: 767px) {
                        padding: 0;
                    }

                    & li {
                        display: inline-block;
                        margin-left: 20px;
                        text-transform: uppercase;
                        @media (max-width: 767px) {
                            margin: 0 10px;
                        }

                        & a {
                            color: #fff;
                            font-weight: 700;

                            &:hover {
                                color: #c8c9cb;
                            }
                        }
                    }
                }
            }
        }
    }

    @keyframes logo {
        0% {
            stroke-width: 1pt;
            stroke-dashoffset: 1200;
            fill-opacity: 0;
        }
        50% {
            fill-opacity: 0;
        }
        100% {
            stroke-dashoffset: 0;
            fill-opacity: 1;
            stroke-width: 0pt;
        }
    }
    :root {
        --font-primary: 'Open Sans', sans-serif;
        --color-gray: #dadce0;
    }
    // Header Menu

    .header {
        &__nav {
            position: relative;
        }
        &__navbar {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin: 0;
        }

        &--icon {
            width: 1.65rem;
            height: 1.65rem;
        }
        &--button {
            top: 0;
            right: 0;
            position: absolute;
            margin: 0;
            padding: 0;
            color: #fff;
            cursor: pointer;
            border: 1px solid transparent;
            background-color: transparent;
            &:focus {
                outline: 0;
            }
        }
        & li {
            list-style: none;
        }
    }

    // Dropdown Menu

    .dropdown__menu {
        top: 100%;
        right: 0;
        position: absolute;
        z-index: 10;
        height: 25rem;
        min-width: 300px;
        margin-top: 1rem;
        overflow-y: auto;
        padding: 2rem 1rem 2rem 0rem;
        border-radius: 12px;
        background-color: white;
        border: 1px solid var(--color-gray);
        background-clip: padding-box;
        @media (max-width:767px) {
            right: -30px;
            height: 100vh;
            margin-top: 1vh;
            border-radius: 0;
            border: 1px solid var(--color-gray);
            width: 100vw;
        }
        &-nav {
            padding: 0;
        }
        &--item {
            padding: 1rem;
        }
        &-link {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            text-decoration: none;
            color: rgba(0, 0, 0, 0.6);
            padding: 0.8rem 0 0.8rem 2rem;
            margin-top: 0.2rem;
            margin-bottom: 0.2rem;
            border-radius: 0 50px 50px 0;
            &:hover {
                color: #17bf63;
                background-color: rgba(79, 192, 141, 0.1);
            }
        }
        &-svg {
            width: 1.5rem;
            height: 1.5rem;
        }
        &-text {
            font-weight: 300;
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }

    // Animation Menu Icon

    .slide-fade-enter-active,
    .slide-fade-leave-active {
        transition: all 0.6s;
    }
    .slide-fade-enter,
    .slide-fade-leave-active {
        opacity: 0;
    }
    .slide-fade-enter {
        transform: translateX(31px);
    }
    .slide-fade-leave-active {
        transform: translateX(-31px);
    }

    // Dropdown Menu Animation

    .dropdown-enter-active,
    .dropdown-leave-active {
        transition: all 1s;
    }
    .dropdown-enter,
    .dropdown-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }

</style>

